<template>
    <div class="dropdown-button">
        <button
            class="filter-search__filter button button_view_icon button_theme_primary button_dropdown-menu"
            :class="[modelValue && 'dropdown-button--button-open']"
            type="button"
            @click.stop="toggle"
        >
            <span class="icon">
                <span class="icon__symbol">
                    <SvgIcon class="icon" :name="buttonIcon" />
                </span>
            </span>
            <slot name="button-badge"></slot>
        </button>

        <BaseDropdownList
            :is-open="modelValue"
            :items="items"
            :sections="sections"
            :active-value="activeValue"
            :active-values="activeValues"
            :multiple="multiple"
            :show-checkbox="showCheckbox"
            :position-class="positionClass"
            :ref-name="refName"
            @select="$emit('select', $event)"
            @close="close"
        >
            <template #item="slotProps">
                <slot name="item" v-bind="slotProps">
                    <span
                        v-if="showCheckbox"
                        class="dropdown-menu__icon icon icon_type_checkbox"
                    >
                        <SvgIcon class="icon" name="common__checkbox" />
                    </span>
                    <span
                        v-if="slotProps.item.icon"
                        class="dropdown-menu__icon icon"
                        :class="slotProps.item.iconClass"
                    >
                       <SvgIcon
                           class="icon"
                           :name="slotProps.item.icon"
                           :style="slotProps.item.iconStyle"
                       />
                    </span>
                    <span class="dropdown-menu__item-name">
                        {{ slotProps.item.label }}
                    </span>
                </slot>
            </template>
        </BaseDropdownList>
    </div>
</template>

<script>
import BaseDropdownList from '@/components/_base/dropdown/BaseDropdownList.vue'

export default {
    name: 'DropdownButton',

    components: {
        BaseDropdownList,
    },

    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        refName: {
            type: String,
        },
        items: {
            type: Array,
            default: () => [],
        },
        sections: {
            type: Array,
            default: () => [],
        },
        activeValue: {
            type: [String, Number, Boolean, Object, null],
            default: null,
        },
        activeValues: {
            type: Array,
            default: () => [],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        showCheckbox: {
            type: Boolean,
            default: false,
        },
        buttonIcon: {
            type: String,
            default: 'common__slider',
        },
        positionClass: {
            type: String,
            default: '',
        },
    },

    emits: ['update:modelValue', 'select'],

    methods: {
        toggle() {
            this.$emit('update:modelValue', !this.modelValue)
        },

        close() {
            this.$emit('update:modelValue', false)
        },
    },
}
</script>

<style scoped lang="scss">
.dropdown-button {
    position: relative;
    .button {
        &::after {
            content: none;
        }
    }
}
</style>